import { createFromProduct, ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import {
    createHandlerChainRunner,
    executeAwaitableHandlerChain,
    Handler,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { getProductByPath } from "@insite/client-framework/Services/ProductServiceV2";
import { recentlyViewedGetProductCollectionParameter } from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";
import loadProductByPath from "@insite/client-framework/Store/Data/Products/Handlers/LoadProductByPath";
import {
    chain,
    LoadProductIfNeeded,
} from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/DisplayProduct";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

type Parameter = {
    path: string;
    styledOption?: string;
};
type Props = {
    product?: ProductModel;
    productInfosById?: SafeDictionary<ProductInfo>;
    variantChildren?: ProductModel[];
    variantChildrenProductInfos?: ProductInfo[];
    variantSelection?: SafeDictionary<string>;
    pricingLoaded?: true;
    inventoryLoaded?: true;
};

type HandlerType = Handler<Parameter, Props>;

export const LoadProductIfNeededExtended: HandlerType = async props => {
    // if variantTypeId is not null this has variantTraits, and we need those loaded fully for this handler chain to work correctly
    if (props.product && props.product.variantTypeId === null) {
        if (
            !props.product.detail ||
            !props.product.content ||
            !props.product.images ||
            !props.product.documents ||
            !props.product.specifications ||
            !props.product.attributeTypes ||
            !props.product.variantTraits
        ) {
            // we don't want to wait for this if we already partially have the product, because then we can't show the partially loaded product page
            props.dispatch(
                loadProductByPath({
                    ...props.parameter,
                    addToRecentlyViewed: true,
                    onComplete: productProps => {
                        const configuration = productProps?.apiResult?.detail?.configuration;
                        if (configuration) {
                            props.dispatch({
                                type: "Pages/ProductDetails/InitConfigurationSelection",
                                configuration,
                            });
                        }

                        props.dispatch({
                            type: "Data/Products/ReplaceDataView",
                            parameter: recentlyViewedGetProductCollectionParameter,
                            dataView: {},
                        });
                    },
                }),
            );
        } else {
            // this is purely so that we can track the recentlyViewed
            getProductByPath({ ...props.parameter, addToRecentlyViewed: true }).then(() => {});
        }

        return;
    }

    props.product = await executeAwaitableHandlerChain(
        loadProductByPath,
        { ...props.parameter, addToRecentlyViewed: true },
        props,
    );
};

replaceInChain(chain, LoadProductIfNeeded, LoadProductIfNeededExtended);
